(function () {
  try {
    var path = window.location.pathname || '';
    var match = path.match(/^\/collections\/([a-z0-9-]+)(?:\/|$)/i);
    var skip = { all: true, frontpage: true, vendors: true };
    if (match && !skip[match[1]]) {
      sessionStorage.setItem(
        'ff_gym_store',
        JSON.stringify({ url: '/collections/' + match[1], handle: match[1] })
      );
    }

    var stored = sessionStorage.getItem('ff_gym_store');
    if (!stored) return;
    var data = JSON.parse(stored);
    if (!data || !data.url) return;

    document.querySelectorAll('[data-ff-continue]').forEach(function (link) {
      var current = link.getAttribute('href') || '';
      if (current.indexOf('/collections/all') !== -1 || current === '/' || current === '') {
        link.setAttribute('href', data.url);
      }
    });
  } catch (error) {}
})();
